module.exports = __webpack_public_path__ + "media/images/tl/banner/th-light-pc-d2d223680b0796d1bcfd2d6b72efe9ea.jpg";